import React, { Component, Fragment } from 'react';
import { Button } from '@material-ui/core';
import { staticImages } from '../../assets/static-images';
import { getTestTimeLimit, taskSegment } from '../assessment/common/task-utility';
import { localDataExpiry, assessmentStatus } from '../../Constants';
import './styles/common-style.scss';

const connectCommon = (WrappedComponent) => {
	return class CommonHOC extends Component {
		constructor(props) {
			super(props);

			this.state = {
				startDate: null,
				testDuration: 0,
				itemStartDate: new Date(),
				itemStartDurationAt: 0,
				itemDuration: 0,
				online: true,
				paused: false,
				pausedStartDate: null,
				pausedDuration: 0,
				disableTimeout: false,
				timeAt25min: false,
				timeAt30min: false,
				timeAt35min: false,
				showSavedPopup: false,
				showTimerOffPopup: false
			};

			this.timeLimit = 2400;
			this.isTimerActive = false;
			this.updateOnlineStatus = this.updateOnlineStatus.bind(this);
			this.saveScreenDuration = this.saveScreenDuration.bind(this);
			this.startTimer = this.startTimer.bind(this);
			this.pauseTimer = this.pauseTimer.bind(this);
			this.disableTimer = this.disableTimer.bind(this);
			this.setShowSavedPopup = this.setShowSavedPopup.bind(this);
			this.setShowTimerOffPopup = this.setShowTimerOffPopup.bind(this);
			this.setRespAtInterval = this.setRespAtInterval.bind(this);
			this.autoSave = this.autoSave.bind(this);
			this.saveBeforeUnload = this.saveBeforeUnload.bind(this);
			this.saveOnBlur = this.saveOnBlur.bind(this);
			this.togglePause = this.togglePause.bind(this);
		}

		componentDidMount() {
			const { match } = this.props;
			const { type } = match.params;

			if (['/Assessment/Complete', '/Assessment/Timeout', `/Assessment/Tasks/${type}/${taskSegment.TASKCOMPLETE}`].includes(this.props.location.pathname)) {
				return;
			}

			window.addEventListener('online', this.updateOnlineStatus);
			window.addEventListener('offline', this.updateOnlineStatus);
			window.addEventListener('beforeunload', this.saveBeforeUnload);
			window.addEventListener('blur', this.saveOnBlur);
			// /\bCrOS\b/.test(navigator.userAgent) && document.addEventListener('visibilitychange');
			(/\bCrOS\b/).test(navigator.userAgent) && document.addEventListener('visibilitychange', this.togglePause);
			this.timeLimit = getTestTimeLimit(this.props.data.userData.grade) * 60;
			this.updateOnlineStatus();
		}

		componentDidUpdate() {
			const { history, location, data, match, logToSentry } = this.props;
			const { type } = match.params;

			if ([`/Assessment/Tasks/${type}/${taskSegment.TASKCOMPLETE}`].includes(location.pathname)) {
				window.removeEventListener('online', this.updateOnlineStatus);
				window.removeEventListener('offline', this.updateOnlineStatus);
				window.removeEventListener('beforeunload', this.saveBeforeUnload);
				window.removeEventListener('blur', this.saveOnBlur);
			}

			if (['/Assessment/Complete', '/Assessment/Timeout', `/Assessment/Tasks/${type}/${taskSegment.TASKCOMPLETE}`].includes(location.pathname)) {
				return;
			}

			if (this.state.testDuration >= this.timeLimit) {
				this.pauseTimer();
				this.saveScreenDuration();

				if (this.state.testDuration - this.timeLimit <= 1000) {
					logToSentry('warning', 'testDuration was slightly greater than timeLimit (<= 1000 ms). This is most likely due to slight inconsistencies when stopping the timer and is expected')
				} else {
					logToSentry('error', `testDuartion was notably greater than timeLimit (${this.state.testDuration - this.timeLimit} ms)`, null, null, 
					{ 
						filename: 'localAssessmentData.json', 
						data: data 
					})
				}

				history.push('/Assessment/Timeout');
			}

			if ('/Assessment/Tasks/ItemList/TaskComplete' === location.pathname) {
				return;
			}

			const currentIndex = data.screens.map(screen => screen.url).indexOf(match.url);

			if (currentIndex !== -1) {
				localStorage.setItem('resumeLocation', location.pathname);
				localStorage.setItem('resumeUser', data.userData.username);
				localStorage.setItem('resumeData', JSON.stringify(data));
				localStorage.setItem('resumeExpiry', (new Date()).getTime() + localDataExpiry);
			}
		}

		componentWillUnmount() {
			window.removeEventListener('online', this.updateOnlineStatus);
			window.removeEventListener('offline', this.updateOnlineStatus);
			window.removeEventListener('beforeunload', this.saveBeforeUnload);
			window.removeEventListener('blur', this.saveOnBlur);
			(/\bCrOS\b/).test(navigator.userAgent) && document.removeEventListener('visibilitychange', this.togglePause);
			this.isTimerActive = false;
			clearInterval(this.timer);
			localStorage.clear();
		}

		updateOnlineStatus() {
			const { match } = this.props;
			this.setState({online: navigator.onLine});
			if (!navigator.onLine) {
				this.pauseTimer();
				this.saveScreenDuration();
			} else if (match.params && match.params.segment === 'Task') {
				if (localStorage.getItem('disableTimeout') === 'true') {
					this.disableTimer();
				} else {
					this.startTimer();
				}
			}
		}

		saveScreenDuration() {
			const { setScreenDuration, location, match } = this.props;
			const { itemStartDate, itemDuration } = this.state;
			const screenDuration = match.params && match.params.segment === 'Task' ? itemDuration : ((new Date() - itemStartDate) / 1000);
			setScreenDuration(location.pathname, screenDuration);
			this.setState(prevState => ({
				itemStartDate: new Date(),
				itemStartDurationAt: prevState.testDuration,
				itemDuration: 0
			}));
		}

		startTimer() {
			const { match } = this.props;
			const { paused, disableTimeout } = this.state;

			if (this.isTimerActive || paused || disableTimeout || (match.params && match.params.segment !== 'Task')) {
				return;
			}

			this.isTimerActive = true;
			const resumeTestDuration = parseFloat(localStorage.getItem('resumeTime')) || 0;
			const resumePausedDuration = parseFloat(localStorage.getItem('pausedDuration')) || 0;

			this.setState({
				startDate: new Date(),
				itemStartDurationAt: resumeTestDuration,
				testDuration: resumeTestDuration,
				pausedDuration: resumePausedDuration
			});

			this.timer = setInterval(() => {
				this.setState(prevState => {
					const testDuration = resumeTestDuration + ((new Date() - prevState.startDate) / 1000);
					return {
						testDuration,
						itemDuration: testDuration - prevState.itemStartDurationAt
					}
				}, () => {
					this.setRespAtInterval();
					localStorage.setItem('resumeTime', this.state.testDuration);
				});
			}, 100);
		}

		pauseTimer(callback) {
			const { data, location, logToSentry } = this.props;
			const { paused, online, disableTimeout, testDuration } = this.state;

			if (disableTimeout) {
				return;
			}

			if (paused && online) {
				logToSentry('info', 'User Unpaused Assessment');
				this.setState(prevState => ({
					itemStartDate: new Date(),
					itemStartDurationAt: prevState.testDuration,
					itemDuration: 0,
					paused: false
				}), () => {
					clearInterval(this.timer);
					this.isTimerActive = false;
					this.startTimer();
				});

				return;
			}

			clearInterval(this.timer);
			this.isTimerActive = false;

			if (online) {
				logToSentry('info', 'User Paused Assessment');
				const resumePausedDuration = parseFloat(localStorage.getItem('pausedDuration')) || 0;
				this.setState({
					paused: true,
					pausedStartDate: new Date(),
					pausedDuration: resumePausedDuration
				});
				this.timer = setInterval(() => {
					this.setState(prevState => ({
						pausedDuration: resumePausedDuration + ((new Date() - prevState.pausedStartDate) / 1000)
					}), () => {
						const { pausedDuration } = this.state;
						data.userData.pausedDuration = pausedDuration;
						localStorage.setItem('pausedDuration', pausedDuration);
					});
				}, 100);
			}

			callback && callback();
		}

		disableTimer() {
			if (this.state.disableTimeout) {
				return;
			}

			clearInterval(this.timer);
			this.isTimerActive = false;

			this.setState({
				disableTimeout: true,
				showTimerOffPopup: true
			});

			localStorage.setItem('disableTimeout', 'true');
		}

		setShowSavedPopup(showSavedPopup, callback) {
			this.setState({showSavedPopup}, () => {
				callback && callback();
			});
		}

		setShowTimerOffPopup(showTimerOffPopup) {
			this.setState({showTimerOffPopup});
		}

		setRespAtInterval() {
			const { testDuration, timeAt25min, timeAt30min, timeAt35min } = this.state;

			if (timeAt25min && timeAt30min && timeAt35min) {
				return;
			}

			const { tasks, setRespAt25min, setRespAt30min, setRespAt35min } = this.props;
			const elapsed = testDuration / 60;

			if (elapsed >= 25 && !timeAt25min) {
				setRespAt25min(tasks);
				this.setState({timeAt25min: true});
			} else if (elapsed >= 30 && !timeAt30min) {
				setRespAt30min(tasks);
				this.setState({timeAt30min: true});
			} else if (elapsed >= 35 && !timeAt35min) {
				setRespAt35min(tasks);
				this.setState({timeAt35min: true});
			}
		}

		autoSave() {
			const { save, data, match, setAssessmentStatus } = this.props;
			const { username, tests } = data.userData;
			const testIndex = tests.findIndex(test => test.versionNum === data.versionID);
			const testData = {
				username,
				testName: tests[testIndex].fullName,
				value: 0,
			};

			if (match.params.segment === 'TaskComplete') {
				setAssessmentStatus(assessmentStatus.Complete);
				testData.forceComplete = true;
				testData.value = 1;
				localStorage.clear();
			} else {
				setAssessmentStatus(assessmentStatus.InProgress);
			}

			this.saveScreenDuration();
			save(testData);
		}

		saveBeforeUnload(event) {
			event.preventDefault();
			this.autoSave();
			return event.returnValue = 'Are you sure you want to close?';
		}

		saveOnBlur() {
			this.autoSave();
		}

		togglePause() {
			this.pauseTimer();
		}

		render() {
			const props = {
				...this.props,
				saveScreenDuration: this.saveScreenDuration,
				startTimer: this.startTimer,
				pauseTimer: this.pauseTimer,
				disableTimer: this.disableTimer,
				setShowSavedPopup: this.setShowSavedPopup
			};

			const { online, paused, showSavedPopup, showTimerOffPopup } = this.state;

			return (
				<Fragment>
					{showSavedPopup && (
						<div className="popup-error">
							<div className="error-box justify-content-center">
								<p className="error-text">Responses saved.</p>
								<Button className="ok-button" onClick={() => this.setShowSavedPopup(false)}>OK</Button>
							</div>
						</div>
					)}
					{showTimerOffPopup && (
						<div className="popup-error">
							<div className="error-box justify-content-center">
								<p className="error-text">Timer turned off.</p>
								{<Button className="ok-button" onClick={() => this.setShowTimerOffPopup(false)}>OK</Button>}
							</div>
						</div>
					)}
					{!online && (
						<div className="popup-error">
							<div className="error-box">
								<img className="error-icon" width="100" height="90" src={staticImages.error} alt="Error" />
								<p className="error-text">Network connection lost: <br />Please contact your administrator.</p>
							</div>
						</div>
					)}
					{!!paused && (
						<div className="popup-error">
							<div className="error-box">
								<img className="error-icon" width="100" height="90" src={staticImages.pause} alt="Pause" />
								<p className="error-text">
									Paused.
									{!online && <><br /><span>(Connection is currently offline)</span></>}
								</p>
							</div>
						</div>
					)}
					<WrappedComponent {...props} />
				</Fragment>
			);
		}
	}
}

export default connectCommon;
